export default __webpack_public_path__ + "static/paperchart-e7178f8aac3afe808392bdc9e31a2151.jpg";